export default {
  user: {
    profile: '個人情報',
    identification: '本人確認',
    bankCard: '銀行カード',
    deposit: '入金',
    withdraw: '出金',
  },
};
